import SSHCF from '@/api/SSHCF';

export default {
  namespaced: true,
  state: {
    regions: [],
    districts: [],
    districtManagers: [],
    companies: [],
    hospitals: [],
    vendors: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 10,
      total_page: 1
    },
    totalData: 0,
    formRequests: [],
    formRequest: null,
    slaReports: [],
    slaReport: null,
    sponsorshipReports: [],
    dashboard: {},
    filter: {
      yearStart: new Date().getFullYear(),
      yearEnd: new Date().getFullYear(),
      house: null,
      region: null,
      district: null,
      status: [],
      isSubmit: false,
      isDownload: false
    },
    ioNumbers: [],
    statuses: [],
    houses: []
  },
  mutations: {
    set(state, payload) {
      Object.keys(payload).forEach(key => {
        if (state.hasOwnProperty(key)) {
          state[key] = payload[key];
        }
      });
    }
  },
  actions: {
    async getRegions({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getRegions(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            regions: result,
            pagination,
            totalData
          });
        } else {
          const regions = data.data;
          commit('set', {
            regions,
            totalData: regions.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDistricts({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getDistricts(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            districts: result,
            pagination,
            totalData
          });
        } else {
          const districts = data.data;
          commit('set', {
            districts,
            totalData: districts.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getHouses({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getHouses(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            houses: result,
            pagination,
            totalData
          });
        } else {
          const houses = data.data.result;
          commit('set', {
            houses,
            totalData: houses.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDistrictsByRegion({ commit }, regionId) {
      try {
        const { data } = await SSHCF.getDistrictsByRegion(regionId);
        const districts = data.data;
        commit('set', {
          districts
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDistrictsManager({ commit }, districtId) {
      try {
        const { data } = await SSHCF.getDistrictsManager(districtId);
        const districtManagers = data.data.result;
        commit('set', {
          districtManagers
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getHospitals({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getHospitals(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            hospitals: result,
            pagination,
            totalData
          });
        } else {
          const hospitals = data.data;
          commit('set', {
            hospitals,
            totalData: hospitals.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getPlants(ctx, params = {}) {
      try {
        const { data } = await SSHCF.getPlants(params);
        return data;
      } catch (e) {
        return [];
      }
    },
    async getVendors({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getVendors(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            vendors: result,
            pagination,
            totalData
          });
        } else {
          const vendors = data.data;
          commit('set', {
            vendors,
            totalData: vendors.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getCompanies({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getCompanies(params);
        if (params.paginate) {
          const { result, pagination, total_data: totalData } = data.data;
          commit('set', {
            companies: result,
            pagination,
            totalData
          });
        } else {
          const companies = data.data;
          commit('set', {
            companies,
            totalData: companies.length
          });
        }
        return data;
      } catch (e) {
        return [];
      }
    },
    async getFormRequests({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getFormRequests(params);
        const formRequests = data.data;
        commit('set', {
          formRequests
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getFormRequestDetail({ commit }, id) {
      commit('set', {
        formRequest: null
      });
      try {
        const { data } = await SSHCF.getFormRequestDetail(id);
        const formRequest = data.data.result;
        commit('set', {
          formRequest
        });
        return data;
      } catch (e) {
        return null;
      }
    },
    async getSLAReports({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getSLAReports(params);
        const slaReports = data.data;
        commit('set', {
          slaReports
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getSLAReportDetail({ commit }, id) {
      try {
        const { data } = await SSHCF.getSLAReportDetail(id);
        const slaReport = data.data.result;
        commit('set', {
          slaReport
        });
        return data;
      } catch (e) {
        return null;
      }
    },
    async syncData(_, resource) {
      try {
        const { data } = await SSHCF.syncData(resource);
        return data;
      } catch (e) {
        return [];
      }
    },
    async copyData(_, resource) {
      try {
        const { data } = await SSHCF.copyData(resource);
        return data;
      } catch (e) {
        return [];
      }
    },
    async getSponsorshipReports({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getSponsorshipReports(params);
        const sponsorshipReports = data.data.result;
        commit('set', {
          sponsorshipReports
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async getDashboard({ commit }, params = {}) {
      try {
        const { data } = await SSHCF.getDashboard(params);
        const dashboard = data.data;
        commit('set', {
          dashboard
        });
        return data;
      } catch (e) {
        return [];
      }
    },
    async uploadFile({ commit }, payload) {
      try {
        const { data } = await SSHCF.uploadFile(payload);
        const uploadFile = data.data;
        commit('set', {
          uploadFile
        });
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async importUsers(ctx, payload) {
      try {
        const { data } = await SSHCF.importUsers(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async uploadFinalMOU(ctx, { formId, payload }) {
      try {
        const { data } = await SSHCF.uploadFinalMOU(formId, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async executeFormRequest(ctx, { formId, payload }) {
      try {
        const { data } = await SSHCF.executeFormRequest(formId, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async createFormRequests(ctx, payload) {
      try {
        const { data } = await SSHCF.createFormRequests(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async updateFormRequest(ctx, { formId, data: payload }) {
      try {
        const { data } = await SSHCF.updateFormRequest(formId, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async publishFormRequest(ctx, { formId, data: payload }) {
      try {
        const { data } = await SSHCF.publishFormRequest(formId, payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async saveAsDraft(ctx, payload) {
      try {
        const { data } = await SSHCF.saveAsDraft(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async getIONumber({ commit }, payload) {
      try {
        const { data } = await SSHCF.getIONumber(payload);
        commit('set', {
          ioNumbers: data.data.result
        });
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async getStatus({ commit }) {
      try {
        const { data } = await SSHCF.getStatus();
        commit('set', {
          statuses: data.data.result
        });
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async getMyAccess({ commit }, payload) {
      try {
        const { data } = await SSHCF.getMyAccess(payload);
        const access = data.data;
        commit('set', {
          access
        });
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async login(ctx, payload) {
      try {
        const { data } = await SSHCF.login(payload);
        return data;
      } catch (err) {
        return err.response.data;
      }
    },
    async importCBS(ctx, file) {
      try {
        const { data } = await SSHCF.importCBS(file);
        return data;
      } catch (e) {
        return e.response.data;
      }
    }
  },
  getters: {
    formRequests: state => state.formRequests,
    formRequest: state => state.formRequest,
    filter: state => state.filter
  }
};
